import React, { useCallback } from 'react';
import { FieldWithState } from '../types/GenericFormTypes';
import { Radio } from '@cube3/cubicle/src/core/atoms/Radio';
import { HBox } from '@cube3/cubicle/src/core/templates/layout/Flex';
import { Typography } from '@cube3/cubicle/src/core/atoms/Typography';
import { Scrollbar } from '@cube3/cubicle/src/core/atoms/Scrollbar';

export type RadioFieldProps = FieldWithState<string, 'radio'>;

export const RadioField = (props: RadioFieldProps) => {
  const { options, flexDirection = 'row', value, disabled, onChange } = props;

  const onClick = useCallback(
    (option: string) => () => {
      if (disabled) return;
      onChange(option);
    },
    [disabled, onChange]
  );

  return (
    <Scrollbar
      autoHeight={true}
      autoHeightMax={175} // can show about 5.5 items
    >
      <div style={{ display: 'flex', flexDirection, gap: 8 }}>
        {options.map((opt) => (
          <HBox
            align="center"
            gap={8}
            key={JSON.stringify(opt)}
            onClick={onClick(opt.value)}
            style={{
              cursor: disabled ? 'default' : 'pointer',
              padding: '4px 0'
            }}
          >
            <Radio value={value === opt.value} disabled={disabled} />
            <Typography colorVariant={disabled ? '03' : '01'}>
              {opt.display_name}
            </Typography>
          </HBox>
        ))}
      </div>
    </Scrollbar>
  );
};
